/**
 * RoleBadge component
 * Displays a color-coded badge for user roles
 */
import { cn } from '@/lib/utils'
import { ROLE_LABELS, ROLE_STYLES, type RoleCode } from '@/types/admin'

export interface RoleBadgeProps {
  /** Role code to display */
  role: RoleCode
  /** Size variant */
  size?: 'sm' | 'md'
  /** Additional CSS classes */
  className?: string
}

/**
 * Color-coded badge for displaying user roles
 */
export function RoleBadge({ role, size = 'sm', className }: RoleBadgeProps) {
  const label = ROLE_LABELS[role] ?? role
  const styles = ROLE_STYLES[role] ?? ROLE_STYLES.visitor

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 font-medium',
        size === 'sm' ? 'text-xs' : 'text-sm',
        styles,
        className
      )}
    >
      {label}
    </span>
  )
}
